import React from 'react'

function DashBoardParceiro() {
  return <div>Parceiro</div>
}

export default DashBoardParceiro
